module.exports = __webpack_public_path__ + "img/wxlecheng.2d4c2486.png";